import { render } from "./SelectedFile.vue?vue&type=template&id=2712bc94&scoped=true"
import script from "./SelectedFile.vue?vue&type=script&lang=js"
export * from "./SelectedFile.vue?vue&type=script&lang=js"

import "./SelectedFile.vue?vue&type=style&index=0&id=2712bc94&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2712bc94"]])

export default __exports__